export interface ShopEnv {
    waasCustomerId: string;
    waasVisitorContainerHostname: string;
}

export function useEnv(): ShopEnv {
    return {
        waasCustomerId: process.env.VUE_APP_WAAS_CUSTOMER_ID,
        waasVisitorContainerHostname:
            process.env.VUE_APP_WAAS_VISITOR_CONTAINER_HOSTNAME,
    };
}
